/** 
 * @type {AssetsFilter} 
 */ 
 const filter = { 
with: null, 
orderBy: null, 
ids: null, 
codes: null, 
names: null, 
cluster_ids: null, 
} 
 /** 
 * @returns {AssetsFilter} 
 */ 
 export default function () { 
 return JSON.parse(JSON.stringify(filter)); 
 } 



// WEBPACK FOOTER //
// ./resources/js/filters/AssetsFilter.js